import { Grid, Typography, Box } from '@mui/material'
import './StudioNav.css'
import { useCreditPoints, } from '../../services/CreditPointsProvider';

function StudioNav() {
     const { creditPoints } = useCreditPoints();
    return (
        <Grid container className='studioMainContainer'>
                <Typography variant="h4" className="studioNavHeading">Cinemotion</Typography>
                {creditPoints < 300 && (
                    <Grid container className='studioNavContainer'>
            <Box className='studioNav'>
                <img src={'/assets/Diamond.svg'} alt='studioLogo' className='studioLogo' />
                <Typography variant="body1" className='studioText'>
                    Buy Credits to enjoy all features in video creation.
                </Typography>
            </Box>
            </Grid>
                )}
            
        </Grid>
    )
}

export default StudioNav;